import { _replace } from 'libs/lodash';

export const removeCsvLastEmptyLine = (csv: string): string => {
  return _replace(csv, /\n$/, '');
};
